import {
  LayoutListDefinition,
  LAYOUT_LIST,
  QUESTION_SEQUENCE,
  QUIZ_CHOICE,
  CAROUSEL,
  CarouselDefinition
} from '../items';
import { QuestionSequenceDefinition } from '../items/question-sequence/QuestionSequence';
import { Translator } from '../Translator';
import { AnswerButtonHelper } from './itemHelpers/AnswerButtonHelpers';
import { CardHelper } from './itemHelpers/CardHelper';
import { TextHelper } from './itemHelpers/TextHelper';
import { ItemOfType } from './itemHelpers/types';
import { translate } from './translate';
import { isMobile } from 'react-device-detect';

export const Cards6: Translator = sequence => {
  const cardsList = {
    type: LAYOUT_LIST,
    id: `${sequence.id}.cardlist`,
    values: {
      orientation: 'row',
      align: 'center',
      padded: true,
      type: 'ul'
    },
    items: [
      {
        id: `${sequence.id}.questionsequence`,
        type: QUESTION_SEQUENCE,
        values: void {},
        items: []
      } as QuestionSequenceDefinition
    ]
  } as LayoutListDefinition;

  const textItems = [] as any;

  const mainList = {
    type: LAYOUT_LIST,
    id: `${sequence.id}.list`,
    values: {
      orientation: 'column',
      align: 'center',
      padded: true
    },
    items: []
  } as LayoutListDefinition;

  const root = translate(sequence, item => {
    if (item.__typename === 'Question') {
      cardsList.items[0].items.push(
        CardHelper(item as ItemOfType<'Question'>, {
          height: 'unset',
          width: '269px',
          padding: '0px',
          isImageDecorative: true,
          type: 'li',
          extraType: 'ul',
          extraItems: [
            {
              id: `${item.id}.quiz`,
              type: QUIZ_CHOICE,
              values: {
                title: item?.title?.includes('?')
                  ? item.title
                  : item?.body?.includes('?')
                  ? item.body
                  : ''
              },
              items: AnswerButtonHelper(
                item.id,
                item.items,
                item.audios?.[0]?.id,
                item.llamaSurvey,
                item.title || ''
              )
            }
          ]
        })
      );
    } else if (item.__typename === 'Card') {
      cardsList.items[0].items.push(
        CardHelper(item as ItemOfType<'Card'>, {
          height: 'unset',
          width: '269px',
          padding: '0px',
          isImageDecorative: true,
          type: 'li'
        })
      );
    } else if (item.__typename === 'Text') {
      textItems.push(TextHelper(item as ItemOfType<'Text'>));

      mainList.items = [
        {
          type: LAYOUT_LIST,
          id: `${sequence.id}.list`,
          values: {
            orientation: 'column',
            align: 'top',
            padded: false
          },
          items: TextHelper(item as ItemOfType<'Text'>)
        } as LayoutListDefinition
      ];
    }

    return null;
  });

  if (isMobile && cardsList?.items[0]?.items) {
    const textData: any = textItems[0] || [];

    root.items.push({
      type: LAYOUT_LIST,
      id: `${sequence.id}.cardlist`,
      values: {
        orientation: 'column',
        align: 'center',
        padded: true,
        type: 'ul'
      },
      items: [
        ...textData,
        {
          id: `${sequence.id}.questionsequence`,
          type: QUESTION_SEQUENCE,
          values: void {},
          items: [
            {
              type: CAROUSEL,
              id: `${sequence.id}.carousel`,
              values: {
                variant: 'horizontal'
              },
              items: cardsList.items[0].items
            } as CarouselDefinition
          ]
        } as QuestionSequenceDefinition
      ]
    } as LayoutListDefinition);
  } else {
    mainList.items.push(cardsList);

    if (mainList.items.length > 1) {
      // adding a dummy item for spacing... bit hackish but ok
      mainList.items.push({
        type: LAYOUT_LIST,
        id: `${sequence.id}.blank`
      } as LayoutListDefinition);
    }

    root.items.push(mainList);
  }

  return root;
};
